import { FormLabel, Grid } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Supplier } from 'api/supplier/suppliers.types';
import { supplierGroupsAPI } from 'api/supplierGroup/supplierGroupAPI';
import { FC } from 'react';
import * as yup from 'yup';
import Form from '../../../../RouteWizard/Form';
import { Select } from '../../../../RouteWizard/Select';
import CredentialFields from '../CredentialFields';
import { IntegrationWizardData } from '../IntegrationSetup';
import {
    getCredentialFields,
    isSingletonSupplierGroup,
} from '../supplierCredentialConfig';

const schema = yup.object().shape({
  supplierGroupId: yup.number().required('Required'),
  endpoint: yup.string().when('supplierGroupId', {
    is: (id: number) => getCredentialFields(Number(id)).includes('endpoint'),
    then: yup.string().required('Required'),
    otherwise: yup.string().notRequired(),
  }),
})

interface CredentialEntryProps {
  supplier: Supplier
  initialValues?: IntegrationWizardData
  onSubmit: (data: IntegrationWizardData) => void
}

const CredentialEntry: FC<CredentialEntryProps> = ({
  supplier,
  initialValues,
  onSubmit,
}) => {
  const supplierGroupList = useQuery({
    queryKey: ['getSupplierGroups'],
    queryFn: async () => supplierGroupsAPI.getSupplierGroups(),
    refetchOnWindowFocus: false,
  })

  const opts = supplierGroupList.data?.data.value.reduce(
    (acc: Record<number, string>, { id, name }) => {
      if (
        name !== undefined &&
        (!isSingletonSupplierGroup(id) || id === supplier.supplierGroupId)
      ) {
        acc[id] = name
      }
      return acc
    },
    {},
  )

  const handleSubmit = (data: IntegrationWizardData) => {
    const selectedGroupId = Number(data.supplierGroupId)
    const currentGroupId = supplier.supplierGroupId

    const isExistingConfig = currentGroupId === selectedGroupId
    const previousSupplierGroupId =
      currentGroupId !== undefined && currentGroupId !== selectedGroupId
        ? currentGroupId
        : undefined

    onSubmit({ ...data, isExistingConfig, previousSupplierGroupId })
  }

  return (
    <Grid container justifyContent="flex-start" sx={{ width: '70%' }}>
      <Form
        schema={schema}
        defaultValues={initialValues ?? {}}
        onSubmit={handleSubmit}
        submitText="Next"
      >
        <FormLabel>Dispatch Platform</FormLabel>
        <Select
          name="supplierGroupId"
          label="Dispatch Platform"
          options={opts}
        />
        <CredentialFields />
      </Form>
    </Grid>
  )
}

export default CredentialEntry
